import { useLocation, useNavigate } from "react-router-dom";
import {
  Box,
  Divider,
  Grid,
  Paper,
  Stack,
  Typography,
  IconButton,
} from "@mui/material";
import CheckCircleOutlineOutlinedIcon from "@mui/icons-material/CheckCircleOutlineOutlined";
import PictureAsPdfIcon from "@mui/icons-material/PictureAsPdf";
import React, { useState } from "react";
import SEO from "../SEO";

const DesktopServiceGuideDetailsItem = () => {
  const location = useLocation();
  const nav = useNavigate();

  if (!location.state) {
    nav("/services-guide");
    return null; // Ensure the component doesn't render if navigation occurs
  }

  const currencyName = location.state?.currency?.[0]?.name || "";
  const {
    name,
    applicationFee,
    compilationTime,
    isPdfExist,
    requiredAttachments,
    pdfPath,
  } = location.state;


  const openPdf = () => {
    window.open(pdfPath, "_blank");
  };

  return (
    <>
    <SEO title={name} />
    <Paper sx={{ p: 3, borderRadius: "10px" }} elevation={5}>
      <Stack gap={2}>
        <Box display="flex" gap={10} justifyContent="flex-start" flexWrap="wrap">
          <Paper
            elevation={2}
            sx={{
              background: "#fff",
              fontWeight: "bold",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              py: 2,
              px: 3,
              borderRadius: "10px",
              border: "2px solid",
              borderColor: "success.main",
              boxShadow: "0px 4px 12px rgba(76, 175, 80, 0.15)",
            }}
          >
            <Typography sx={{ fontWeight: "bold", color: "success.main" }}>
              رسوم الطلب: {applicationFee} {currencyName}
            </Typography>
          </Paper>
          <Paper
            elevation={2}
            sx={{
              background: "#fff",
              fontWeight: "bold",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              py: 2,
              px: 3,
              borderRadius: "10px",
              border: "2px solid",
              borderColor: "primary.main",
              boxShadow: "0px 4px 12px rgba(25, 118, 210, 0.15)",
            }}
          >
            <Typography sx={{ fontWeight: "bold", color: "primary.main" }}>
              {`الوقت اللازم لإنجاز الطلب: ${
                compilationTime ? `${compilationTime} ايام` : ""
              }`}
            </Typography>
          </Paper>
          <Paper
            elevation={2}
            sx={{
              background: "#fff",
              fontWeight: "bold",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              gap: 1,
              py: 2,
              px: 3,
              borderRadius: "10px",
              border: "2px solid",
              borderColor: "error.main",
              boxShadow: "0px 4px 12px rgba(211, 47, 47, 0.15)",
              "& .MuiButtonBase-root": {
                padding: 0,
              },
            }}
          >
            <Typography sx={{ fontWeight: "bold", color: "error.main" }}>دليل الخدمة :</Typography>
            <IconButton
              color={"error"}
              disabled={!isPdfExist}
              onClick={openPdf}
            >
              <PictureAsPdfIcon sx={{ padding: 0 }} />
            </IconButton>
          </Paper>
        </Box>
        <Grid sx={{ backgroundColor: "primary.main", p: 2, mt: 2 }} container>
          <Grid textAlign="right" color="#fff" md={4} item>
            <Typography sx={{ fontWeight: "bold" }}>نوع المرفق</Typography>
          </Grid>
          <Grid textAlign="center" color="#fff" md={4} item>
            <Typography sx={{ fontWeight: "bold" }}>اجباري</Typography>
          </Grid>
          <Grid textAlign="center" color="#fff" md={4} item>
            <Typography sx={{ fontWeight: "bold" }}>اختياري</Typography>
          </Grid>
        </Grid>
        <Grid container spacing={3} sx={{ p: 2 }}>
          {requiredAttachments.map((t, i) => (
            <React.Fragment key={i}>
              <Grid textAlign="right" md={4} item>
                <Typography sx={{ fontWeight: "bold" }}>
                  {t.attachmentType}
                </Typography>
              </Grid>
              <Grid textAlign="center" md={4} item>
                {t.isMandatory ? (
                  <CheckCircleOutlineOutlinedIcon htmlColor="#32CE37" />
                ) : null}
              </Grid>
              <Grid textAlign="center" md={4} item>
                {!t.isMandatory ? (
                  <CheckCircleOutlineOutlinedIcon htmlColor="#32CE37" />
                ) : null}
              </Grid>
              <Grid md={12} item>
                {requiredAttachments.length - 1 !== i && (
                  <Divider sx={{ backgroundColor: "primary.main" }} />
                )}
              </Grid>
            </React.Fragment>
          ))}
        </Grid>
      </Stack>
    </Paper>
    </>
  );
};

export default DesktopServiceGuideDetailsItem;
